import React from 'react'
import { Card } from 'react-bootstrap'
import { AccordionSection, AccordionCard } from '../../accordion'
import { formatCurrency } from 'application/helpers'
import { Tabs } from '@mmsg/louie'
import TaxImplicationsTable from './taxImplicationsTable'
import * as S from './estimateDetailElements'

interface IInputProps {
  fbtPerPay: number
  lcdaPerPay: number
  isTaxShare: boolean
  erSharePerPay: number
  gstOnECMPerPay: number
  greenfleetPerPay: number
  erAdminFeePerPay: number
  fbtPerAnnum: number
  lcdaPerAnnum: number
  erSharePerAnnum: number
  gstOnECMPerAnnum: number
  greenfleetPerAnnum: number
  erAdminFeePerAnnum: number
  isExGST: boolean
  fbtMethod?: string
  overTheCapMethod?: string
  payFrequency: string
}

const TaxImplicationsSection = (props: IInputProps) => {
  const displayGstOnECM = () => {
    if (!props.isExGST) return false

    if (props.fbtMethod && props.fbtMethod.toLowerCase().includes('ecm'))
      return true
    if (
      props.overTheCapMethod &&
      props.overTheCapMethod.toLowerCase().includes('ecm')
    )
      return true

    return false
  }

  return (
    props.fbtPerPay +
      props.lcdaPerPay +
      (props.isTaxShare ? props.erSharePerPay : 0) +
      (displayGstOnECM() ? props.gstOnECMPerPay : 0) +
      props.greenfleetPerPay +
      props.erAdminFeePerPay !==
      0 && (
      <Card className="mb-13rem print-page-break-before card-shadow">
        <Card.Header className="border-bottom-0 d-flex justify-content-between">
          <S.CardHeader className="text-header">
            Tax implications and other charges
          </S.CardHeader>
          <S.CardHeaderValue id="runningsection.taximplications">
            {formatCurrency(
              props.fbtPerPay +
                props.lcdaPerPay +
                (props.isTaxShare ? props.erSharePerPay : 0) +
                (displayGstOnECM() ? props.gstOnECMPerPay : 0) +
                props.greenfleetPerPay +
                props.erAdminFeePerPay
            )}
          </S.CardHeaderValue>
        </Card.Header>
        <Card.Body>
          <AccordionSection
            readerText="Tax implications and other charges"
            expandAccordion={false}
            title="Novated leasing includes a charge (or, depending on your circumstances, charges) determined by the ATO in exchange for the potential benefits you’ll receive."
            id="runningsection.fbtcharge"
            defaultActive={false}
          >
            <Tabs
              data={[
                {
                  title: props.payFrequency,
                  content: () => (
                    <TaxImplicationsTable
                      fbt={props.fbtPerPay}
                      lcda={props.lcdaPerPay}
                      erShare={props.erSharePerPay}
                      gstOnECM={props.gstOnECMPerPay}
                      greenfleet={props.greenfleetPerPay}
                      erAdminFee={props.erAdminFeePerPay}
                      id={`lease-fees-${props.payFrequency}`}
                      gstOnECM_isDisplayed={displayGstOnECM()}
                      erShare_isDisplayed={props.isTaxShare}
                      isExGST={props.isExGST}
                    />
                  ),
                },
                {
                  title: 'Annually',
                  content: () => (
                    <TaxImplicationsTable
                      fbt={props.fbtPerAnnum}
                      lcda={props.lcdaPerAnnum}
                      erShare={props.erSharePerAnnum}
                      gstOnECM={props.gstOnECMPerAnnum}
                      greenfleet={props.greenfleetPerAnnum}
                      erAdminFee={props.erAdminFeePerAnnum}
                      id={`lease-fees-Annually`}
                      gstOnECM_isDisplayed={displayGstOnECM()}
                      erShare_isDisplayed={props.isTaxShare}
                      isExGST={props.isExGST}
                    />
                  ),
                },
              ]}
              activeIndex={0}
              equalWidth
            />
          </AccordionSection>
          {props.lcdaPerAnnum > 0 && (
            <div>
              <AccordionCard
                expandAccordion={false}
                className="mb-24"
                title="Why am I being charged Luxury Car Depreciation Allowance (LCDA) but haven’t leased a luxury car?"
                id="runningsection.whylcdaaccordion"
                defaultActive={false}
                smallerTitleText={false}
              >
                <p>
                  Even though you may not be leasing a vehicle which is
                  considered a luxury car by the Australian Tax Office, LCDA is
                  a cost recovered by Maxxia on behalf of your employer for any
                  amount you're financing that is greater than the Luxury
                  Vehicle Limit set by the ATO.
                </p>
              </AccordionCard>
              <AccordionCard
                expandAccordion={false}
                className="mb-24"
                title="What’s the difference between Luxury Car Tax and LCDA?"
                id="runningsection.lctlcdadiffaccordion"
                defaultActive={false}
                smallerTitleText={false}
              >
                <p>
                  Luxury Car Tax is an amount required to be collected by the
                  dealer on behalf of the ATO, whereas LCDA is an amount
                  collected by Maxxia on behalf of your employer.
                </p>
              </AccordionCard>
            </div>
          )}
        </Card.Body>
      </Card>
    )
  )
}

export default TaxImplicationsSection
